<ng-template #cross>
  <svg
    class="w-6 h-6 text-slate-300 hover:text-slate-500 dark:text-gray-400 dark:hover:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M6 18 17.94 6M18 18 6.06 6"
    />
  </svg>
</ng-template>

<ng-template #envelope>
  <svg
    class="w-6 h-6 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      d="M2.038 5.61A2.01 2.01 0 0 0 2 6v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6c0-.12-.01-.238-.03-.352l-.866.65-7.89 6.032a2 2 0 0 1-2.429 0L2.884 6.288l-.846-.677Z"
    />
    <path
      d="M20.677 4.117A1.996 1.996 0 0 0 20 4H4c-.225 0-.44.037-.642.105l.758.607L12 10.742 19.9 4.7l.777-.583Z"
    />
  </svg>
</ng-template>

<ng-template #envelope>
  <svg
    class="w-6 h-6 text-sky-950 dark:text-indigo-300"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="2"
      d="m3.5 5.5 7.893 6.036a1 1 0 0 0 1.214 0L20.5 5.5M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
    />
  </svg>
</ng-template>

<ng-template #padlock>
  <svg
    class="w-6 h-6 text-slate-300 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      d="M8 10V7a4 4 0 1 1 8 0v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1Zm2-3a2 2 0 1 1 4 0v3h-4V7Zm2 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
      clip-rule="evenodd"
    />
  </svg>
</ng-template>

<ng-template #caretDown>
  <svg
    class="w-2.5 h-2.5 text-slate-300 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 6"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m1 1 4 4 4-4"
    />
  </svg>
</ng-template>

@if (modalService.emailPreferencesModal()) {
<!-- Scrim (sm+ only) -->
<div
  class="hidden sm:block fixed inset-0 bg-black/40 backdrop-blur-sm z-[9989] transition-opacity"
  (click)="closeModal()"
></div>
<!-- Dialog: fullscreen on mobile, bottom-anchored on sm+ -->
<div
  animate.enter="animate-enter-medium-up"
  animate.leave="animate-leave-medium-up"
  class="fixed inset-0 z-[9990] flex flex-col items-stretch bg-white p-safe dark:bg-gray-700 sm:self-center sm:m-auto sm:min-w-72 sm:max-w-144 sm:-max-h-svh-safe-offset-16 sm:rounded-3xl"
>
  <!-- Header -->
  <div
    class="self-stretch min-h-14 flex flex-row justify-between gap-2 border-b border-gray-300 p-safe-or-6 sm:border-0 sm:pt-safe-or-6 sm:px-safe-or-6 sm:pb-0"
  >
    <!-- Left -->
    <div class="flex-1 flex items-center justify-start gap-4">
      <button class="sm:hidden" (click)="closeModal()" aria-label="Close">
        <ng-container *ngTemplateOutlet="cross"></ng-container>
      </button>
      <div class="flex flex-col gap-1">
        <h2 class="text-base sm:text-lg text-zinc-900 dark:text-indigo-50">
          Email Preferences
        </h2>
        <div class="text-xs sm:text-sm text-zinc-700 dark:text-slate-300">
          Manage how you hear from Land IQ Daily ET
        </div>
      </div>
    </div>
    <!-- Right -->
    <button
      (click)="save()"
      [disabled]="!hasUnsavedChanges() || saving()"
      class="sm:hidden self-center px-2 py-2 text-xs sm:text-sm font-semibold text-blue-600 hover:text-blue-700 disabled:opacity-50 disabled:cursor-not-allowed dark:text-blue-400 dark:hover:text-blue-300"
    >
      {{ saving() ? 'Saving…' : 'Save' }}
    </button>
  </div>
  <!-- Scrollable body -->
  <div
    class="flex-1 min-h-0 flex flex-col gap-6 overflow-y-scroll py-6 px-safe-or-6 sm:mt-6"
  >
    @if (subscriptionsResource.isLoading()) {
    <div class="text-sm text-gray-500 dark:text-gray-400 p-4">Loading…</div>
    } @else { @for (sub of subscriptionsResource.value() ?? []; track
    sub.topicId) {
    <!-- Email preferences card -->
    <div
      class="flex flex-col items-stretch gap-4 p-4 border border-gray-300 rounded-md bg-gray-100 dark:bg-zinc-800 dark:border-gray-700"
    >
      <!-- Card Header -->
      <div class="flex-1 flex flex-col">
        <!-- Header first row -->
        <div class="flex flex-row justify-between items-start gap-4 w-full">
          <!-- Left -->
          <div
            class="flex flex-col justify-center items-center py-3 px-2.5 dark:bg-blue-600 rounded-lg"
          >
            <ng-container *ngTemplateOutlet="envelope"></ng-container>
          </div>
          <!-- Group Right -->
          <div class="flex-1 flex flex-col gap-2">
            <!-- Title & Sub -->
            <div class="flex flex-row justify-between items-center">
              <h3
                class="text-sm sm:text-base font-regular text-zinc-900 dark:text-indigo-50"
              >
                {{ sub.displayName }}
              </h3>
              <!-- Switch -->
              <div class="relative flex flex-row items-center gap-3">
                <label
                  for="toggle-{{ sub.topicId }}"
                  class="text-xs sm:text-sm"
                  [ngClass]="{
                    'text-sky-950 dark:text-indigo-50': isSubscribed(sub.topicId),
                    'text-gray-500 dark:text-gray-400': !isSubscribed(sub.topicId)
                  }"
                >
                  {{ isSubscribed(sub.topicId) ? 'Subscribed' : 'Unsubscribed'}}
                </label>
                <input
                  id="toggle-{{ sub.topicId }}"
                  name="toggle-{{ sub.topicId }}"
                  class="sr-only peer"
                  type="checkbox"
                  [checked]="isSubscribed(sub.topicId)"
                  (change)="toggleStatus(sub.topicId)"
                />
                <!-- Actual switch div -->
                <label
                  for="toggle-{{ sub.topicId }}"
                  class="relative cursor-pointer h-8 w-14 p-0.5 rounded-3xl bg-gray-300 peer-checked:bg-sky-950 dark:bg-zinc-700 dark:peer-checked:bg-indigo-500 transition-colors duration-[var(--duration-expressive-fast-effects)] ease-[var(--ease-expressive-fast-effects)] after:absolute after:inset-y-0 after:my-auto after:left-1 after:h-4 after:w-4 peer-checked:after:w-6 peer-checked:after:h-6 after:rounded-full after:bg-white peer-checked:after:translate-x-6 after:transition-transform after:duration-[var(--duration-expressive-fast-spatial)] after:ease-[var(--ease-expressive-fast-spatial)]"
                ></label>
              </div>
            </div>
            <!-- Description -->
            @if(emailStubData[sub.slug]) {
            <div
              class="text-sm sm:text-base text-zinc-700 dark:text-slate-300 capitalize"
            >
              {{ emailStubData[sub.slug].description }}
            </div>
            }
          </div>
        </div>
      </div>
      <!-- Card Content -->
      <div
        class="flex flex-col gap-4 border-gray-300 dark:border-gray-700 transition-all duration-[var(--duration-expressive-fast-spatial)] ease-[var(--ease-expressive-fast-spatial)]"
        [ngClass]="{
          'border-t pt-4 ': isExpanded(sub.topicId)
        }"
      >
        @if(emailStubData[sub.slug] &&
        emailStubData[sub.slug].emailIncludeCardInfo.length > 0) {
        <button
          class="flex flex-row items-center gap-2"
          (click)="toggleCard(sub.topicId)"
        >
          <div
            class="text-sm sm:text-base caret-rotate transition-transform"
            [class.open]="isExpanded(sub.topicId)"
          >
            <ng-container *ngTemplateOutlet="caretDown"></ng-container>
          </div>
          <h3
            class="text-sm sm:text-base font-regular text-zinc-900 dark:text-indigo-50"
          >
            What's included in this email
          </h3>
        </button>
        @if(isExpanded(sub.topicId)) {
        <ul
          animate.enter="animate-enter-down"
          animate.leave="animate-leave-down"
          class="grid grid-cols-2 gap-3"
        >
          @for(stubData of emailStubData[sub.slug].emailIncludeCardInfo; track
          stubData.title){
          <div
            class="flex flex-row items-center gap-3 p-3 bg-white border border-gray-300 rounded-md dark:border-gray-700 dark:bg-gray-900"
          >
            <div [innerHTML]="trustSvg(stubData.icon)"></div>
            <div class="text-sm sm:text-base text-zinc-700 dark:text-slate-300">
              {{ stubData.title }}
            </div>
          </div>
          }
        </ul>
        } }
      </div>
    </div>
    } @empty {
    <div class="text-sm sm:text-base text-zinc-700 dark:text-slate-300">
      No email topics available. Please check back later.
    </div>
    } }
    <!-- Delivered to -->
    @if(email && (subscriptionsResource.value()?.length ?? 0) > 0){
    <div class="flex flex-col gap-3">
      <h3 class="text-sm sm:text-base text-zinc-900 dark:text-indigo-50">
        Delivered to
      </h3>
      <div
        class="flex flex-row gap-2 bg-white border border-gray-300 rounded-md p-2.5 items-center w-full dark:bg-gray-500/50 dark:border-gray-600"
      >
        <ng-container *ngTemplateOutlet="padlock"></ng-container>
        <span class="text-sm sm:text-base text-zinc-700 dark:text-slate-300"
          >{{ email }}</span
        >
      </div>
    </div>
    }
  </div>
  <!-- Footer (sm+ only) -->
  <div
    class="hidden sm:flex flex-row justify-end items-center gap-4 p-safe-or-6"
  >
    <button
      (click)="closeModal()"
      class="rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
    >
      Cancel
    </button>
    <button
      (click)="save()"
      [disabled]="!hasUnsavedChanges() || saving()"
      class="px-4 py-2 text-sm font-semibold text-blue-600 hover:text-blue-700 disabled:opacity-50 disabled:cursor-not-allowed dark:text-blue-400 dark:hover:text-blue-300"
    >
      {{ saving() ? 'Saving…' : 'Save' }}
    </button>
  </div>
</div>
}
